<template>
    <div>
      <InnerNewsList :dataLink="dataLink"  :dateBlock="false"></InnerNewsList>
    </div>
</template>
 
<script>
import InnerNewsList from  './InnerNewsList' //内部新闻列表
export default {
    components:{
      InnerNewsList
    },
    data(){
        return{
          dataLink:"",
        }
    },
    created(){
      var allcanshu=[];
      this.dataLink="";
      for (var x in this.$route.query){
          if(x=="datalink"){
              allcanshu.push(this.$route.query[x]);
          }else{
              allcanshu.push(x+'='+this.$route.query[x]);
          } 
      }
      this.dataLink = allcanshu.join("&");
    }
}
</script>

<style>
</style>